var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8356 2.25259C12.2145 1.9158 12.7855 1.9158 13.1644 2.25259L22.1644 10.2526C22.5772 10.6195 22.6143 11.2516 22.2474 11.6644C21.8805 12.0771 21.2484 12.1143 20.8356 11.7474L20.5 11.4491V19C20.5 20.1046 19.6046 21 18.5 21H6.50001C5.39544 21 4.50001 20.1046 4.50001 19V11.4491L4.16437 11.7474C3.75159 12.1143 3.11952 12.0771 2.7526 11.6644C2.38568 11.2516 2.42286 10.6195 2.83565 10.2526L11.8356 2.25259ZM6.50001 9.67129V19H9.50001V14C9.50001 13.4477 9.94773 13 10.5 13H14.5C15.0523 13 15.5 13.4477 15.5 14V19H18.5V9.67129L12.5 4.33795L6.50001 9.67129ZM13.5 19V15H11.5V19H13.5Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeDisabled);
export default __webpack_public_path__ + "static/media/icon_home_disabled.11739ee9bacbddde7767c7eccedda788.svg";
export { ForwardRef as ReactComponent };